module.exports = __webpack_public_path__ + "static/media/icon-check.fe2c6490.svg";